import { Component, EventEmitter, OnDestroy, OnInit, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormArray, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'split-select-week',
  templateUrl: './select-week.component.html',
  styleUrls: ['./select-week.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectWeekComponent),
      multi: true,
    }
  ]
})
export class SelectWeekComponent implements OnInit, ControlValueAccessor, OnDestroy {
  horarios: SelectItem[] = this.gerarHorarios();
  disabled = false;
  value: any;
  onChangeSubs: Subscription[] = [];
  weekLabel = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"];
  initialTime: any
  endTime: any

  @Output() isValid = new EventEmitter<boolean>();
  @Output() disabledDay = new EventEmitter<number>();

  onChange: any = () => { };
  onTouched: any = () => { };

  form = this.fb.group({
    switch: false,
    weekDay: 0,
    periods: this.fb.array([] as FormGroup<any>[])
  })

  constructor(private fb: FormBuilder) {
    //this.addPeriod()
  }

  get periods() {
    return this.form.controls["periods"];
  }

  ngOnInit(): void {
    this.periods.valueChanges.subscribe(res => {
      //console.log('mudou valor: ', res)
      this.validateTime()
    })
  }

  addPeriod() {
    const periodForm = this.fb.group({
      horarioIni: ['', Validators.required],
      horarioFim: ['', Validators.required],
    })
    this.periods.push(periodForm)
  }

  removePeriod(periodIndex: number) {
    this.periods.removeAt(periodIndex);
  }

  toggle() {
    if (!this.form.value.switch) {
      this.isValid.emit(true)
      this.disabledDay.emit(this.form.value.weekDay as number)
      this.periods.clear()
    } else {
      this.addPeriod()
    }
  }

  gerarHorarios() {
    const horarios = [];

    for (let horas = 0; horas < 24; horas++) {
      for (let minutos = 0; minutos < 60; minutos += 5) {
        const horaFormatada = horas.toString().padStart(2, '0');
        const minutoFormatado = minutos.toString().padStart(2, '0');
        const horario = `${horaFormatada}:${minutoFormatado}`;

        horarios.push({ label: horario, value: horario });
      }
    }

    return horarios;
  }

  writeValue(value: any) {
    this.value = value;
    if (value) {
      this.periods.clear()

      this.form.controls['weekDay'].setValue(value.weekDay, { emitEvent: false })
      this.form.controls['switch'].setValue(value.switch, { emitEvent: false })

      value.periods?.forEach((item: any) => {
        if (
          item.horarioIni != null &&
          item.horarioIni != '' &&
          item.horarioFim != null &&
          item.horarioFim != '' && 
          (item.horarioIni != '00:00' || item.horarioFim != '00:00')
        ) {

          const periodForm = this.fb.group({
            horarioIni: [item.horarioIni, Validators.required],
            horarioFim: [item.horarioFim, Validators.required],
          })
          this.periods.push(periodForm)
        }

      });

      //this.form.setValue(value, {emitEvent: false});
    }
    if (this.periods.length == 0) {
      //this.addPeriod()
    }
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
    const sub = this.form.valueChanges.subscribe(onChange);
    this.onChangeSubs.push(sub);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnDestroy() {
    for (let sub of this.onChangeSubs) {
      sub.unsubscribe();
    }
  }

  validateTime(){
    for(let element of this.periods.value){
      this.isValid.emit(this.compareTimes(element.horarioIni, element.horarioFim))

      if(!this.compareTimes(element.horarioIni, element.horarioFim)){
        break;
      }
    }
  }

  compareTimes(first: string, second: string) {

    const [hour1, minutes1] = first.split(':').map(Number)
    const [hour2, minutes2] = second.split(':').map(Number)

    if (hour2 > hour1) {
      return true
    } else if (hour2 == hour1 && minutes2 > minutes1) {
      return true
    } else { return false }

  }


}
